    export default class automationMessage{
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/automation/directives/automation-message.html'),
            scope: {
                automation: '=',
                message: '=',
                first: '=',
                last: '=',
                trigger: '=',
                membersDiff: '=',
                customDateFields: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$filter', '$state', 'Events', 'TimePrinter', 'Automation', 'SweetAlert',
                (scope, element, attr, $filter, $state, Events, TimePrinter, Automation, SweetAlert) => {

                scope.messageTypeMap = {
                    1: 'email',
                    2: 'textMessage'
                };

                scope.toggleMessageActivation = (message) => {
                    var messageType = scope.isEmail(message) ? 1 : 2;

                    if (message.active) {
                        Automation.activateMessage(scope.automation.id, message.id, messageType).then(() => {
                            Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:MESSAGE_ACTIVATED'));
                        }, () => { //error
                            message.active = false;
                            Events.flashEvent('error', $filter('translate')('AUTOMATION:FLASH:MESSAGE_NOT_ACTIVATED'));
                        });
                    } else {
                        Automation.deactivateMessage(scope.automation.id, message.id, messageType).then(() => {
                            Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:MESSAGE_DEACTIVATED'));
                        }, () => { //error
                            message.active = true;
                            Events.flashEvent('error', $filter('translate')('AUTOMATION:FLASH:MESSAGE_NOT_DEACTIVATED'));
                        });
                    }
                };

                scope.delaySettings = () => {
                    scope.message['showSettings'] = ! scope.message['showSettings'];
                };

                scope.isEmail = (message) => {
                    return message.message_type_id == 1;
                };

                scope.delayToSpoken = (seconds) => {
                    if (seconds == 0) {
                        return $filter('translate')('AUTOMATION:INDEX:NO_DELAY');
                    }

                    return TimePrinter.unitToSpoken(seconds, 'seconds');
                };

                scope.toStatistics = (message) => {
                    var folderName = message.message_type_id == 2 ? 'received' : 'open';
                    var messageType = scope.messageTypeMap[message.message_type_id];
                    $state.go('automation.statistics', {
                        id: message.id,
                        folder: folderName ,
                        automationId: scope.automation.id,
                        messageType: messageType
                    });
                };

                scope.editMessage = (message) => {
                    if (scope.isEmail(message)) {
                        $state.go('automation.emailEdit', { id: scope.automation.id, emailId: message.id });
                    } else {
                        $state.go('automation.smsEdit', { id: scope.automation.id, textMessageId: message.id });
                    }
                };

                scope.deleteMessage = (message) => {
                    SweetAlert.swal({
                        title: $filter('translate')('GLOBAL:FLASH:DELETE'),
                        text: $filter('translate')('AUTOMATION:FLASH:DELETE_MESSAGE_EXPLAINED'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: $filter('translate')('GLOBAL:YES'),
                        cancelButtonText: $filter('translate')('GLOBAL:NO')
                    }, (isConfirm) => {
                        if (isConfirm) {
                            Automation.removeMessage(
                                scope.automation.id,
                                message.id,
                                message.message_type_id
                            ).then(() => {
                                message.removed = true;
                                Events.flashEvent('notification', $filter('translate')('AUTOMATION:INDEX:MESSAGE_REMOVED'));
                            });
                        }
                    });
                };
            }]
        }
    }
}